import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'

/** The only namespace for now: every member-facing string is in `en.json` (copy v7 wording). */
export const NS = 'en'

/** Languages written right to left (none is shipped yet; the hook is in place for the next locale). */
export function applyDocumentDirection(lng: string): void {
  if (typeof document === 'undefined') return
  document.documentElement.dir = i18next.dir(lng)
  document.documentElement.lang = lng
}

if (!i18next.isInitialized) {
  void i18next.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    ns: [NS],
    defaultNS: NS,
    resources: { en: { [NS]: en } },
    // React already escapes what it renders.
    interpolation: { escapeValue: false },
    returnNull: false,
  })
  applyDocumentDirection('en')
  i18next.on('languageChanged', applyDocumentDirection)
}

export default i18next
